import script from "./CollapseArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseArrow.vue?vue&type=script&setup=true&lang=js"

import "./CollapseArrow.vue?vue&type=style&index=0&id=06598d3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06598d3e"]])

export default __exports__